<template>
    <div v-if="items != null && items.length > 0" class="vehicle-page-flow__accordion">
        <p class="vehicle-page-flow__headline">Ofte stillede spørgsmål</p>
        <Accordion :multiple="true">
            <AccordionTab v-if="items != null" v-for="(item, index) in items" :key="index" :header="item.title">
                <div v-html="item.content">
                </div>
            </AccordionTab>
        </Accordion>
    </div>
</template>
<script>
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
export default {
    name: "flowAccordion",
    props: ['items'],
    components: {
        Accordion,
        AccordionTab
    }
};
</script>
